/* eslint-disable */

import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";

import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";

import { ReactComponent as PersonList } from "../Assets/svg/PersonList.svg";
import { ReactComponent as DownloadIcon } from "../Assets/svg/DownloadIcon.svg";


import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";


import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";

// import moment from "moment-jalaali"
import moment from "jalali-moment"
import { ReactComponent as SreachIcon } from "../Assets/svg/SreachIcon.svg";

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';

import Cookies from 'js-cookie'

import http from '../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../Components/persian-mobile-datepicker-config'
import ModalComponent from './ModalComponent';
import { SearchCities } from './PublicFunctions';
import { ReactComponent as ArrowRightIconGreen } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as WhiteSearchIcon } from "../Assets/svg/WhiteSearchIcon.svg";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { satisfactionPercent } from '../api/ListData';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function EditRelationsModal(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [Users, setUsers] = React.useState([]);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [adaptPercent, setAdaptPercent] = useState(false);
    const [relationsDataCreate, setRelationsDataCreate] = useState({});
    const [rTypeSlected, setRTypeSlected] = useState("");
    const [relationListModal, setRelationListModal] = useState(false);
    const [relationListLoading, setRelationListLoading] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);
    const [deleteConnModal, setDeleteConnModal] = useState(false);
    const [idSelectedForDel, setIdSelectedForDel] = useState("");
    const [relationList, setRelationList] = useState([]);
    const [relationLoading, setRelationLoading] = useState(false);

    const handleClickAdaptPercent = (id) => {
        setAdaptPercent(true);
    };
    const handleAdaptPercentClose = () => {
        setAdaptPercent(false);
    };

    const handleDeleteConnModalOpen = (id) => {
        setIdSelectedForDel(id)
        setDeleteConnModal(true);
    };
    const handleDeleteConnModalClose = () => {
        setDeleteConnModal(false);
    };



    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const getUsers = async () => {
        handleToggleBackdrop()
        setUsersLoading(true)
        try {
            const usersRes = await http({
                url: "/users/get-my-users",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(usersRes)

            if (usersRes.data.result.Users.length) {
                setUsers(usersRes.data.result.Users)
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()
        setUsersLoading(false)
    }

    const handleClickOpenUsersModal = (index) => {
        setRTypeSlected(index)
        getUsers()

        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };

    const dataFetchedRef = useRef(false);


    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        setRelationsDataCreate({
            "PropertyId": props.propInfo.Id
        })


        console.log("moment", moment.from('2024-01-30 18:13:06', 'en', 'YYYY-MM-DD H:i:s').locale('fa').format('jYYYY/jMM/jDD'))

        console.log("relationToEdit", props.relationToEdit)
        //relationsDataCreate
        const tmp = {
            Id: props?.relationToEdit?.Id,
            PhoneCall: props?.relationToEdit?.PhoneCall,
            Visit: props?.relationToEdit?.Visit,
            SMS: props?.relationToEdit?.SMS,
            InPerson: props?.relationToEdit?.InPerson,
            PropertyId: props?.relationToEdit?.PropertyId,
            PropertyRow: props?.relationToEdit?.PropertyRow,
            FullName: props?.relationToEdit?.FullName,
            ApplicantId: props?.relationToEdit?.ApplicantId,
            SatisfactionPercent: props?.relationToEdit?.SatisfactionPercent,
            
        }


         

        setRelationsDataCreate(tmp)


        
    }, [])

    useEffect(() => {
        console.log("relationsDataCreate", relationsDataCreate)
        console.log("time",moment(relationsDataCreate?.PhoneCall?.Time))
    }, [relationsDataCreate])

    const formatJalali = (timestamp) => {
        console.log("timestamp", moment(timestamp).format("jYYYY/jMM/jDD"))
        return moment(timestamp).format("jYYYY/jMM/jDD")
        // try {
        //     return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        // } catch (e) {
        //     console.log("error", e)
        //     return timestamp;
        // }
    }

    const [showPicker, setShowPicker] = React.useState(false);



    const handleChangeRelationsDataCreate = (value, index) => {
        const tmp = { ...relationsDataCreate }
        tmp[index] = value
        setRelationsDataCreate(tmp)
    }

    const handleChangeRelationsPercent = (e, index) => {
        const tmp = { ...relationsDataCreate }
        console.log('checked', e.target.checked)
        if (e.target.checked)
            tmp[index] = e.target.value
        else
            delete tmp[index]

        setRelationsDataCreate(tmp)

        handleAdaptPercentClose()
    }

    const handleChangeRelationType = (e, index) => {
        const tmp = { ...relationsDataCreate }

        if (index in tmp) {
            delete tmp[index]
        } else {
            tmp[index] = {
                "Date": new Date(),
                "Time": "",
                "UserId": ""
            }
        }


        setRelationsDataCreate(tmp)
    }

    const handleChangeRelationTypeDate = (date, index) => {
        const tmp = { ...relationsDataCreate }
        tmp[index].Date = +date.date
        setRelationsDataCreate(tmp)
    }

    const handleChangeRelationTypeTime = (time, index) => {
        console.log("tiem ",time)
        const tmp = { ...relationsDataCreate }
        tmp[index].Time = `${time.$d.getHours()}:${time.$d.getMinutes()}`
        setRelationsDataCreate(tmp)
    }


    const handleSetUser = (user) => {
        const tmp = { ...relationsDataCreate }
        // console.log("user",user)
        tmp[rTypeSlected].UserId = user.id
        tmp[rTypeSlected].username = user.username
        setRelationsDataCreate(tmp)
        handleOpenUsersModalClose()
    }

    const handlesubmitRelationsDataCreate = async () => {
        setRelationLoading(true)

        handleToggleBackdrop()

        try {
            const response = await http({
                url: `/properties/connections/${relationsDataCreate?.Id}/edit`,
                method: "POST",
                data: relationsDataCreate,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(response)
            if (response.data.result) {
                const variant = 'success'
                enqueueSnackbar('ارتباط شما با موفقیت ویرایش شد.', { variant });
                props.handleEditRelationsModalClose()

            } else {
                const variant = 'error'
                enqueueSnackbar(response.data.message, { variant });
            }



        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()

        setRelationLoading(false)
    }




    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalComponent showModalState={props.editRelationsModal} handleModalClose={props.handleEditRelationsModalClose} modalTitle="" modalSubmitBtn={!relationLoading && handlesubmitRelationsDataCreate} modalTitleSubmitBtn="ویرایش">
                <Box>
                    ویرایش ارتباط با متقاضی
                </Box>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                    <Box className="inputs-container flex-1">
                        <InputBase placeholder='کد تقاضا'  type="number"  value={relationsDataCreate?.Row} onChange={e => handleChangeRelationsDataCreate(e.target.value, "Row")} />
                    </Box>
                    <IconButton sx={{ backgroundColor: '#29A19C!important' }}>
                        <WhiteSearchIcon />
                    </IconButton>
                </Box> */}
                <Box className={`${relationsDataCreate.PhoneCall ? 'isChecked' : ""}`} sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <Box>
                        <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox checked={relationsDataCreate.PhoneCall ? true : false} onChange={e => handleChangeRelationType(e, "PhoneCall")} />} label="تماس تلفنی" />
                    </Box>
                    {
                        relationsDataCreate.PhoneCall ?
                            <>
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>در تاریخ</label>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', mt: 1 }}>
                                        <Box className="inputs-container flex-1 children-auto has-timepicker" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <div className='flex-1 w-chile-100'>
                                                <InputBase value={formatJalali(relationsDataCreate.PhoneCall.Date)} className='flex-1' onClick={() => setShowPicker(true)} />
                                                <Picker
                                                    isOpen={showPicker}
                                                    config={config}
                                                    value={relationsDataCreate.PhoneCall.Date ? new Date(relationsDataCreate.PhoneCall.Date) : new Date()}
                                                    initialValue={relationsDataCreate.PhoneCall.Date ? new Date(relationsDataCreate.PhoneCall.Date) : new Date()}
                                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                    onSubmit={date => handleChangeRelationTypeDate(date, "PhoneCall")}
                                                    // onChange={date => handleChangeRelationTypeDate(date, "PhoneCall")}
                                                    onClose={() => setShowPicker(false)}
                                                    highlightWeekends
                                                />
                                            </div>
                                            <Box>
                                                ساعت
                                            </Box>
                                            <LocalizationProvider className="timepicker-container" dateAdapter={AdapterDayjs} localeText={{ okButtonLabel: "باشه", cancelButtonLabel: "لغو", timePickerToolbarTitle: "زمان را انتخاب کنید" }}>
                                                <DemoContainer components={['MobileTimePicker', 'MobileTimePicker']}>
                                                    <MobileTimePicker value={moment(relationsDataCreate?.PhoneCall?.Time)} className='timepicker-input' openTo="seconds" onAccept={time => handleChangeRelationTypeTime(time, "PhoneCall")} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            <CalendarIcon />
                                        </Box>

                                    </Box>
                                </Box>
                                <Box>
                                    انجام خواهد شد/گردید
                                </Box>
                                <Box>
                                    <label className='f-14 text-label'>کاربر</label>
                                    <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal("PhoneCall")} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>{relationsDataCreate.PhoneCall.username ? `توسط ${relationsDataCreate.PhoneCall.username}` : "کاربر خود را انتخاب کنید"}</span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box>
                            </>
                            : ""}
                </Box>
                <Box className={`${relationsDataCreate.SMS ? 'isChecked' : ""}`} sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox checked={relationsDataCreate.SMS ? true : false} onChange={e => handleChangeRelationType(e, "SMS")} />} label="معرفی با ارسال پیام" />
                    {
                        relationsDataCreate.SMS ?
                            <>
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>در تاریخ</label>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', mt: 1 }}>
                                        <Box className="inputs-container flex-1 children-auto has-timepicker" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <div className='flex-1 w-chile-100'>
                                                <InputBase value={formatJalali(relationsDataCreate.SMS.Date)} className='flex-1' onClick={() => setShowPicker(true)} />
                                                <Picker
                                                    isOpen={showPicker}
                                                    config={config}
                                                    value={relationsDataCreate.SMS.Date ? new Date(relationsDataCreate.SMS.Date) : new Date()}
                                                    initialValue={relationsDataCreate.SMS.Date ? new Date(relationsDataCreate.SMS.Date) : new Date()}
                                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                    onSubmit={date => handleChangeRelationTypeDate(date, "SMS")}
                                                    // onChange={date => handleChangeRelationTypeDate(date, "SMS")}
                                                    onClose={() => setShowPicker(false)}
                                                    highlightWeekends
                                                />
                                            </div>
                                            <Box>
                                                ساعت
                                            </Box>
                                            <LocalizationProvider className="timepicker-container" dateAdapter={AdapterDayjs} localeText={{ okButtonLabel: "باشه", cancelButtonLabel: "لغو", timePickerToolbarTitle: "زمان را انتخاب کنید" }}>
                                                <DemoContainer components={['MobileTimePicker', 'MobileTimePicker']}>
                                                    <MobileTimePicker defaultValue={moment(relationsDataCreate?.SMS?.Time)} className='timepicker-input' openTo="seconds" onAccept={time => handleChangeRelationTypeTime(time, "SMS")} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            <CalendarIcon />
                                        </Box>

                                    </Box>
                                </Box>
                                <Box>
                                    انجام خواهد شد/گردید
                                </Box>
                                <Box>
                                    <label className='f-14 text-label'>کاربر</label>
                                    <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal("SMS")} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>{relationsDataCreate.SMS.username ? `توسط ${relationsDataCreate.SMS.username}` : "کاربر خود را انتخاب کنید"}</span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box>
                            </>
                            : ""}
                </Box>
                <Box className={`${relationsDataCreate.InPerson ? 'isChecked' : ""}`} sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox checked={relationsDataCreate.InPerson ? true : false} onChange={e => handleChangeRelationType(e, "InPerson")} />} label="معرفی حضوری" />
                    {
                        relationsDataCreate.InPerson ?
                            <>
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>در تاریخ</label>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', mt: 1 }}>
                                        <Box className="inputs-container flex-1 children-auto has-timepicker" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <div className='flex-1 w-chile-100'>
                                                <InputBase value={formatJalali(relationsDataCreate.InPerson.Date)} className='flex-1' onClick={() => setShowPicker(true)} />
                                                <Picker
                                                    isOpen={showPicker}
                                                    config={config}
                                                    value={relationsDataCreate.InPerson.Date ? new Date(relationsDataCreate.InPerson.Date) : new Date()}
                                                    initialValue={relationsDataCreate.InPerson.Date ? new Date(relationsDataCreate.InPerson.Date) : new Date()}
                                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                    onSubmit={date => handleChangeRelationTypeDate(date, "InPerson")}
                                                    // onChange={date => handleChangeRelationTypeDate(date, "InPerson")}
                                                    onClose={() => setShowPicker(false)}
                                                    highlightWeekends
                                                />
                                            </div>
                                            <Box>
                                                ساعت
                                            </Box>
                                            <LocalizationProvider className="timepicker-container" dateAdapter={AdapterDayjs} localeText={{ okButtonLabel: "باشه", cancelButtonLabel: "لغو", timePickerToolbarTitle: "زمان را انتخاب کنید" }}>
                                                <DemoContainer components={['MobileTimePicker', 'MobileTimePicker']}>
                                                    <MobileTimePicker defaultValue={moment(relationsDataCreate?.InPerson?.Time)} className='timepicker-input' openTo="seconds" onAccept={time => handleChangeRelationTypeTime(time, "InPerson")} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            <CalendarIcon />
                                        </Box>

                                    </Box>
                                </Box>
                                <Box>
                                    انجام خواهد شد/گردید
                                </Box>
                                <Box>
                                    <label className='f-14 text-label'>کاربر</label>
                                    <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal("InPerson")} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>{relationsDataCreate.InPerson.username ? `توسط ${relationsDataCreate.InPerson.username}` : "کاربر خود را انتخاب کنید"}</span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box>
                            </>
                            : ""}
                </Box>
                <Box className={`${relationsDataCreate.Visit ? 'isChecked' : ""}`} sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox checked={relationsDataCreate.Visit ? true : false} onChange={e => handleChangeRelationType(e, "Visit")} />} label="بازدید از ملک" />
                    {
                        relationsDataCreate.Visit ?
                            <>
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>در تاریخ</label>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', mt: 1 }}>
                                        <Box className="inputs-container flex-1 children-auto has-timepicker" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <div className='flex-1 w-chile-100'>
                                                <InputBase value={formatJalali(relationsDataCreate.Visit.Date)} className='flex-1' onClick={() => setShowPicker(true)} />
                                                <Picker
                                                    isOpen={showPicker}
                                                    config={config}
                                                    value={relationsDataCreate.Visit.Date ? new Date(relationsDataCreate.Visit.Date) : new Date()}
                                                    initialValue={relationsDataCreate.Visit.Date ? new Date(relationsDataCreate.Visit.Date) : new Date()}
                                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                    onSubmit={date => handleChangeRelationTypeDate(date, "Visit")}
                                                    // onChange={date => handleChangeRelationTypeDate(date, "Visit")}
                                                    onClose={() => setShowPicker(false)}
                                                    highlightWeekends
                                                />
                                            </div>
                                            <Box>
                                                ساعت
                                            </Box>
                                            <LocalizationProvider className="timepicker-container" dateAdapter={AdapterDayjs} localeText={{ okButtonLabel: "باشه", cancelButtonLabel: "لغو", timePickerToolbarTitle: "زمان را انتخاب کنید" }}>
                                                <DemoContainer components={['MobileTimePicker', 'MobileTimePicker']}>
                                                    <MobileTimePicker defaultValue={moment(relationsDataCreate?.Visit?.Time)} className='timepicker-input' openTo="seconds" onAccept={time => handleChangeRelationTypeTime(time, "Visit")} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            <CalendarIcon />
                                        </Box>

                                    </Box>
                                </Box>
                                <Box>
                                    انجام خواهد شد/گردید
                                </Box>
                                <Box>
                                    <label className='f-14 text-label'>کاربر</label>
                                    <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal("Visit")} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>{relationsDataCreate.Visit.username ? `توسط ${relationsDataCreate.Visit.username}` : "کاربر خود را انتخاب کنید"}</span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box>
                            </>
                            : ""}
                </Box>
                <Box sx={{ display: "flex", gap: "20px", alignItems: "center", fontSize: "16px" }}>
                    <Box>کد ملک : </Box>
                    <Box>{props.propInfo?.Row}</Box>
                </Box>
                <Box>
                    <label className='f-14 text-label'>درصد رضایت متقاضی</label>
                    <Box className={`inputs-container`} onClick={handleClickAdaptPercent} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        <span>{relationsDataCreate.SatisfactionPercent ? relationsDataCreate.SatisfactionPercent : 'درصد رضایتمندی خود را انتخاب کنید'}</span>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Box>
                </Box>

            </ModalComponent>



            {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className="inputs-container" sx={{ display: "flex", justifyContent: "center", width: "100%", p: 1 }} key={index} onClick={() => handleSetUser(item)}>


                                            <Typography component="span">{item.username}</Typography>

                                            {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                {/* <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button> */}
            </Dialog>
            }

            {
                adaptPercent && <ModalComponent showModalState={adaptPercent}
                    handleModalClose={handleAdaptPercentClose}
                    modalTitle=""
                    disableSubmitBtn={true}
                >
                    <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <input type="checkbox" id='percentAdapt1' className="d-none typeCheck" name="percentAdapt" value="<50" checked={relationsDataCreate.SatisfactionPercent && relationsDataCreate.SatisfactionPercent == "<50"} onChange={(e) => handleChangeRelationsPercent(e, "SatisfactionPercent")} />
                            <label htmlFor='percentAdapt1' className='typeLabel check-has-arrow w-100 d-flex justify-content-around'>
                                <div>کمتر از 50 درصد</div>
                            </label>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <input type="checkbox" id='percentAdapt2' className="d-none typeCheck" name="percentAdapt" value="50-80" checked={relationsDataCreate.SatisfactionPercent && relationsDataCreate.SatisfactionPercent == "50-80"} onChange={(e) => handleChangeRelationsPercent(e, "SatisfactionPercent")} />
                            <label htmlFor='percentAdapt2' className='typeLabel check-has-arrow w-100 d-flex justify-content-around'>
                                <div>بین 50 تا 80 درصد</div>
                            </label>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <input type="checkbox" id='percentAdapt3' className="d-none typeCheck" name="percentAdapt" value=">80" checked={relationsDataCreate.SatisfactionPercent && relationsDataCreate.SatisfactionPercent == ">80"} onChange={(e) => handleChangeRelationsPercent(e, "SatisfactionPercent")} />
                            <label htmlFor='percentAdapt3' className='typeLabel check-has-arrow w-100 d-flex justify-content-around'>
                                <div>80 درصد به بالا</div>
                            </label>
                        </Box>

                    </Box>
                </ModalComponent>
            }




        </>
    );
}

export default EditRelationsModal;